import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_MATERIAL = [
  {
    module: 'MATERIAL',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'nome', active: true, removable: false },
      { field: 'categoria.descricao', active: true, removable: true },
      { field: 'unidade.descricao', active: true, removable: true },
      { field: 'quantidade', active: true, removable: true },
      { field: 'valor_unitario', active: true, removable: true }
    ]
  },
  {
    module: 'REE_MATERIAL',
    colunas: [
      { field: 'numero', active: true, removable: true },
      { field: 'data', active: true, removable: true },
      {
        field: 'fornecedor.nome_razao_social',
        active: true,
        removable: false
      },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'RSE_MATERIAL',
    colunas: [
      { field: 'numero', active: true, removable: false },
      { field: 'data', active: true, removable: true },
      { field: 'observacao', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  }
] as IColunasSettingsUser[];
